module.exports = __webpack_public_path__ + "static/img/ios7.ba61e387.jpg";